import usePrivateAxios from '@/common/api/usePrivateAxios'
import { EstablishmentCompanyData } from '@/common/types/establishment/company.type'
import { UpdateFeesConfigurationsValidationSchema } from '@/features/establishments/schemas/politics/updateFeesConfigurations.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateEstablishmentFeesConfigurationsProps {
  establishmentCompany?: EstablishmentCompanyData;
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateEstablishmentFeesConfigurations = ({
  establishmentCompany,
  onSuccess,
  onError,
}: UseUpdateEstablishmentFeesConfigurationsProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updateEstablishmentFeesConfigurations', establishmentCompany?.id],
    mutationFn: async (form: UpdateFeesConfigurationsValidationSchema) => {
      const payload = {
        special_fee_application_mode: form.special_fee_application_mode?.value || undefined,
      };

      return privateAxios.put(`/establishment/companies/${establishmentCompany?.id}/update_fees_configurations`, {
        company: payload,
      });
    },
    onSuccess,
    onError,
  });
}
